import { useMutation, useQueryClient } from 'react-query'

import { useCurrentSite } from '../../components/SitesProvider'
import request from '../../config/axios'
import QueryKeys from './QueryKeys'

export interface UpdateNoteData {
  id: string
  notableId: string
  notableType: string
  content: string
}

interface UpdateNoteResponse {
  note: {
    id: string
    // add additional note fields as needed
  }
}

const useUpdateNote = () => {
  const queryClient = useQueryClient()
  const siteId = useCurrentSite()?.id

  return useMutation((data: UpdateNoteData) => {
    // Use the note's id and a trusted siteId in the URL
    const url = `/impacts/notes/${data.id}?site_id=${siteId}`
    return request
      .patch<UpdateNoteResponse>(url, {
        siteIds: [siteId],
        note: {
          content: data.content,
          siteId, // included in the payload if needed by your API
        },
      })
      .then((r) => {
        queryClient.invalidateQueries(
          QueryKeys.notes({
            notableId: data.notableId,
            notableType: data.notableType,
          }),
        )
        return r.data.note
      })
  })
}

export default useUpdateNote
